export const getUrlQueryEncode = (query = {}) => {
  const result = {};
  for (const key in query) {
    const item = query[key];

    if (Array.isArray(item)) {
      result[key] = item.toString();
    } else if (typeof item === 'boolean') {
      result[key] = item;
    } else if (typeof item === 'number') {
      result[key] = item;
    } else if (item === null || item) {
      result[key] = item;
    }
  }
  return result;
};

export const getUrlQueryDecode = (query = {}) => {
  const result = {};

  for (const key in query) {
    const item = query[key];

    if (typeof item === 'string') {
      if (item.length && item.match(/,/gi)) {
        const array = item.split(',');
        result[key] = array;
      } else {
        result[key] = item;
      }
    } else if (item) {
      result[key] = item;
    }
  }

  return result;
};

export const getUrlCurrentQuery = (filters = {}) => {
  const result = {};
  for (const key in filters) {
    const item = filters[key];

    if (item) {
      result[key] = item;
    }
  }

  return result;
};

export const getUrlParams = (params = '') => new URLSearchParams(params);

export const isURLAbsolute = (value = '') => {
  const str = String(value);

  return str.startsWith('https://') || str.startsWith('http://') || str.startsWith('//');
};

// создание урла которым можно поделиться
export const createUrlCustomizerParams = ({ system, model, models = [], material, size }) => {
  const systemIndexFind = system ? models.findIndex(({ id }) => id === system?.id) : null;

  const modelIndexFind =
    typeof systemIndexFind === 'number' && systemIndexFind >= 0 && model
      ? models[systemIndexFind].models?.findIndex(({ id }) => id === model?.id)
      : null;

  const viewStr = [
    typeof systemIndexFind === 'number' && systemIndexFind >= 0 && systemIndexFind + 1,
    typeof modelIndexFind === 'number' && modelIndexFind >= 0 && modelIndexFind + 1,
    material?.vendor_code,
  ]
    .filter(Boolean)
    .join(',');

  const sizeStr = [size?.width, size?.height].filter(Boolean).join(',');

  const params = [viewStr && `view=${viewStr}`, sizeStr && `size=${sizeStr}`]
    .filter(Boolean)
    .join('&');

  const url = `${location.origin}${params ? `?${params}` : ''}`;

  return url;
};
